<template>
  <div v-if="list.length > 0">
    <h2>{{ title }}</h2>
    <table style="margin-top:10px;">
      <thead>
        <tr>
          <th scope="col">Date</th>
          <th scope="col">Type</th>
          <th scope="col">Payment Deduction</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(tableItem, idx) in list" :key="idx">
          <td>{{ formatDate(tableItem.date) }}</td>
          <td>
            <div class="table-value-group">
              <div v-if="!tableItem.isEditing">{{ tableItem.t }}</div>
              <template v-if="tableItem.isEditing && editable">
                <select
                  class="select"
                  v-model="list[idx].deduction_type"
                  v-if="tableItem.tag !== 'timeoff'"
                >
                  <option :value="null" disabled="true">Select Type...</option>
                  <option
                    v-for="(option, optionIdx) in timeoffs"
                    :key="optionIdx"
                    >{{ option }}</option
                  >
                </select>
              </template>
              <i
                v-if="tableItem.tag !== 'timeoff' && editable"
                class="fas fa-edit green-col pointer"
                @click="tableItem.isEditing = !tableItem.isEditing"
              ></i>
            </div>
          </td>
          <td v-if="editable">
            <div class="table-value-group" v-if="!tableItem.ignore_attendance">
              <input
                :disabled="list[idx].deduction_type !== 'Late'"
                type="number"
                v-model.number="list[idx].deduction_amount"
              />
              <template>
                <div
                  class="green-label pointer"
                  @click="updateAttendance(tableItem)"
                >
                  SAVE
                </div>
              </template>
            </div>
            <div class="table-value-group" v-else>-</div>
          </td>
          <td v-else>{{ tableItem.deduction_amount }}</td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td></td>
          <td>Total</td>
          <td>{{ total }}</td>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
// import { constants } from '../js/regents'
import dayjs from 'dayjs';
import { http } from '../digilib_web/core/digitify';

export default {
  computed: {
    editable() {
      return this.profile.role === 'admin';
    },
    total() {
      let rows = this.list;
      let total = 0;
      for (let i = 0; i < rows.length; ++i) {
        total += rows[i].deduction_amount;
      }
      return `Rp. ${total.toLocaleString()}`;
    },
    timeoffs() {
      return ['On Time', 'Late'];
    }
  },
  props: {
    id: Number,
    profile: Object,
    list: Array,
    title: String
  },
  methods: {
    formatDate(d) {
      return dayjs(d).format('ddd, DD MMM YYYY');
    },
    updateAttendance(item) {
      let date = dayjs(item.d).format('YYYY-MM-DD');
      // if late, set at 10 am
      let clockInTime =
        item.deduction_type === 'Late'
          ? `${date}T10:00:00+08:00`
          : `${date}T07:00:00+08:00`;
      let payload = { deduction: item.deduction_amount, clock_in: clockInTime };
      // update attendance deduction and clock in time
      http
        .put(`employees/attendance/${item.id_attendance}`, payload)
        .then(() => {
          this.$emit('shouldReload');
        });
    }
  }
};
</script>
